import { dayOfWeek } from '@/enums/dayOfWeek';

export class dayOfWeekModel {
	constructor(value: string, text: string) {
		this.value = value;
		this.text = text;
	}
	value: string;
	text: string;
}